<template>
  <div
    :class="['container', className]"
    :style="{ width: `${width + 4}px`, height: `${height + 4}px` }"
  >
    <div v-if="!playing" class="idle-container" :style="{ backgroundImage: `url(${thumbnail})` }">
      <div class="button" @click="play">
        <i class="fas fa-play"></i>
      </div>
    </div>
    <iframe
      v-if="playing"
      :src="src"
      :width="width"
      :height="height"
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      class="max-w-full"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    thumbnail: String,
    autoplay: Boolean,
    className: String,
    width: Number,
    height: Number,
  },

  data() {
    return {
      playing: false,
    };
  },

  computed: {
    src() {
      return `https://www.youtube.com/embed/${this.id}?autoplay=${
        this.autoplay ? 1 : 0
      }`;
    },
  },

  methods: {
    play() {
      this.playing = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  @apply bg-almost-black;
}

.idle-container {
  @apply w-full h-full;
  @apply flex items-center justify-center;

  background-size: cover;
  background-position: center center;
}

.button {
  @apply h-16 w-16;
  @apply flex items-center justify-center;
  @apply rounded-full cursor-pointer;
  @apply bg-almost-black-light;
}
</style>
